export default {
  path: '/board',
  name: 'board',
  redirect: { name: 'job.feed-page' },
  component: () => import(/* webpackChunkName: "board" */ '@/views/board'),
  children: [
    {
      path: '/boards/main/new/:id',
      name: 'board.new-main-board-page',
      component: () =>
        import(/* webpackChunkName: "new-board-page" */ '@/views/board/NewBoardPage.vue')
    },
    {
      path: '/boards/distribution/new/:id/:parentId',
      name: 'board.new-distribution-board-page',
      component: () =>
        import(/* webpackChunkName: "new-board-page" */ '@/views/board/NewBoardPage.vue')
    },
    {
      path: '/boards/layout/:name/:id',
      name: 'board.board-layout-page',
      component: () =>
        import(/* webpackChunkName: "board-layout-page" */ '@/views/board/BoardLayoutPage.vue')
    },
    {
      path: '/boards/:name/:id',
      name: 'board.board-details-page',
      component: () =>
        import(/* webpackChunkName: "board-details-page" */ '@/views/board/BoardDetailsPage.vue')
    },
    {
      path: '/boards/changelog/:name/:id',
      name: 'board.view-change-log',
      component: () =>
        import(/* webpackChunkName: "view-change-log" */ '@/views/board/ViewChangeLog.vue')
    }
  ]
}
